// extracted by mini-css-extract-plugin
module.exports = {"card":"TitleCard_card__aK7bR","title":"TitleCard_title__2ypzZ","children":"TitleCard_children__JYnOh","vertical":"TitleCard_vertical__2WyEl"};